import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class PackageInstalledWidgetsService extends RestfulService<Models.PackageInstalledWidget> {

  constructor(private restService: RestService) {
    super(Models.PackageInstalledWidget);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('package-installed-widgets');
  }

}
